import {
  FETCH_FORM_TYPES_SUCCESS,
  FETCH_FORM_TYPES_FAIL,
  CREATE_FORM_INSTANCE_SUCCESS,
  CREATE_FORM_INSTANCE_FAIL,
  FETCH_FORM_STRUCTURE_SUCCESS,
  FETCH_FORM_STRUCTURE_FAIL,
  ADD_FORM_INSTANCE_ID_TO_REDUX,
  FORM_ENTRY_ADDED_SUCCESS,
  FORM_ENTRY_ADDED_FAIL,
  RESET_FORM_REDUX_STATE,
  FORM_ENTRY_RENDERED_SUCCESS,
  FORM_ENTRY_RENDERED_FAIL,
  FETCH_PDF_TEMPLATES_SUCCESS,
  FETCH_PDF_TEMPLATES_FAIL,
  UPLOAD_PDF_TEMPLATE_SUCCESS,
  DELETE_PDF_TEMPLATE_SUCCESS,
  SET_ACTIVE_PDF_TEMPLATE,
  SAVE_PDF_TEMPLATE_FIELDS_SUCCESS,
  CREATE_PDF_TEMPLATE_INSTANCE_SUCCESS,
  CREATE_PDF_TEMPLATE_INSTANCE_FAIL,
  UPDATE_PDF_TEMPLATE_INSTANCE_SUCCESS,
  RENDER_PDF_TEMPLATE_INSTANCE_SUCCESS,
  RESET_PDF_TEMPLATE_STATE,
} from "../Actions/Types";

const initialState = {
  formTypes: null,
  formInstance: null,
  formInstanceID: null,
  formStructure: null,
  formEntryAdded: false,
  renderFilledForm: null,
  formInstanceName: null,
  // PDF Templates
  pdfTemplates: null,
  activePDFTemplate: null,
  pdfTemplateInstance: null,
  pdfTemplateInstanceID: null,
  renderedPDFUrl: null,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case FETCH_FORM_TYPES_SUCCESS:
      return {
        ...state,
        formTypes: action.payload,
      };
    case FETCH_FORM_TYPES_FAIL:
      return {
        ...state,
        formTypes: null,
      };
    case CREATE_FORM_INSTANCE_SUCCESS:
      return {
        ...state,
        formInstance: action.payload,
      };
    case CREATE_FORM_INSTANCE_FAIL:
      return {
        ...state,
        formInstance: null,
      };
    case FETCH_FORM_STRUCTURE_SUCCESS:
      return {
        ...state,
        formStructure: action.payload,
      };
    case FETCH_FORM_STRUCTURE_FAIL:
      return {
        ...state,
        formStructure: null,
      };
    case ADD_FORM_INSTANCE_ID_TO_REDUX:
      return {
        ...state,
        formInstanceID: action.payload.id,
        formInstanceName: action.payload.name,
      };
    case FORM_ENTRY_ADDED_SUCCESS:
      return {
        ...state,
        formEntryAdded: true,
      };
    case FORM_ENTRY_ADDED_FAIL:
      return {
        ...state,
        formEntryAdded: false,
      };
    case RESET_FORM_REDUX_STATE:
      return {
        ...state,
        formInstance: null,
        formInstanceID: null,
        formStructure: null,
        formEntryAdded: false,
      };
    case FORM_ENTRY_RENDERED_SUCCESS:
      return {
        ...state,
        renderFilledForm: action.payload,
      };
    case FORM_ENTRY_RENDERED_FAIL:
      return {
        ...state,
        renderFilledForm: null,
      };

    // PDF Template cases
    case FETCH_PDF_TEMPLATES_SUCCESS:
      return { ...state, pdfTemplates: action.payload };
    case FETCH_PDF_TEMPLATES_FAIL:
      return { ...state, pdfTemplates: null };
    case UPLOAD_PDF_TEMPLATE_SUCCESS:
      return {
        ...state,
        pdfTemplates: state.pdfTemplates
          ? [action.payload, ...state.pdfTemplates]
          : [action.payload],
      };
    case DELETE_PDF_TEMPLATE_SUCCESS:
      return {
        ...state,
        pdfTemplates: state.pdfTemplates
          ? state.pdfTemplates.filter((template) => template.id !== action.payload)
          : state.pdfTemplates,
        activePDFTemplate:
          state.activePDFTemplate?.id === action.payload ? null : state.activePDFTemplate,
      };
    case SET_ACTIVE_PDF_TEMPLATE:
      return { ...state, activePDFTemplate: action.payload };
    case SAVE_PDF_TEMPLATE_FIELDS_SUCCESS:
      return {
        ...state,
        activePDFTemplate: state.activePDFTemplate
          ? { ...state.activePDFTemplate, fields: action.payload.fields }
          : state.activePDFTemplate,
      };
    case CREATE_PDF_TEMPLATE_INSTANCE_SUCCESS:
      return {
        ...state,
        pdfTemplateInstance: action.payload,
        pdfTemplateInstanceID: action.payload.id,
      };
    case CREATE_PDF_TEMPLATE_INSTANCE_FAIL:
      return { ...state, pdfTemplateInstance: null, pdfTemplateInstanceID: null };
    case UPDATE_PDF_TEMPLATE_INSTANCE_SUCCESS:
      return { ...state, pdfTemplateInstance: action.payload };
    case RENDER_PDF_TEMPLATE_INSTANCE_SUCCESS:
      return { ...state, renderedPDFUrl: action.payload.pdf_url };
    case RESET_PDF_TEMPLATE_STATE:
      return {
        ...state,
        activePDFTemplate: null,
        pdfTemplateInstance: null,
        pdfTemplateInstanceID: null,
        renderedPDFUrl: null,
      };

    default:
      return state;
  }
}
